import { Project } from "../../../../../types";

export const getOpenProjects = (projects: Project[]) =>
  projects.filter((project) => !project.closed);